import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '0px'
}} transition={{
  duration: 0.6,
  delay
}} className={className} data-id="element-272">
    {children}
  </motion.div>;
export const Button = ({
  href,
  children,
  variant = 'primary',
  className = ''
}: {
  href: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
}) => {
  const baseStyle = 'inline-flex items-center justify-center px-6 md:px-8 py-4 rounded-full font-bold transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-xl text-center leading-tight';
  const variants = {
    primary: 'bg-gradient-to-r from-gold-400 via-gold-500 to-gold-600 text-navy-900 hover:shadow-gold-500/40 relative overflow-hidden group',
    secondary: 'bg-navy-800 text-white border border-navy-600 hover:bg-navy-700 hover:border-gold-500/50'
  };
  return <motion.a href={href} className={`${baseStyle} ${variants[variant]} ${className}`} whileHover={{
    y: -2
  }} animate={variant === 'primary' ? {
    boxShadow: ['0 10px 15px -3px rgba(212, 175, 55, 0.1)', '0 10px 25px -3px rgba(212, 175, 55, 0.4)', '0 10px 15px -3px rgba(212, 175, 55, 0.1)'],
    scale: [1, 1.02, 1]
  } : {}} transition={variant === 'primary' ? {
    duration: 2,
    repeat: Infinity,
    ease: 'easeInOut'
  } : {}} data-id="element-273">
      {variant === 'primary' && <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:animate-shine" data-id="element-274" />}
      <span className="relative z-10" data-id="element-275">{children}</span>
    </motion.a>;
};
export const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 16,
    seconds: 48
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center space-x-2 text-2xl md:text-4xl font-serif font-bold text-gold-400" data-id="element-276">
      <div className="bg-navy-800 px-4 py-2 rounded-lg border border-navy-700 shadow-inner" data-id="element-277">
        {format(timeLeft.hours)}
        <span className="text-sm text-gray-400 block font-sans font-normal" data-id="element-278">
          hs
        </span>
      </div>
      <span className="text-gold-500 pb-6" data-id="element-279">:</span>
      <div className="bg-navy-800 px-4 py-2 rounded-lg border border-navy-700 shadow-inner" data-id="element-280">
        {format(timeLeft.minutes)}
        <span className="text-sm text-gray-400 block font-sans font-normal" data-id="element-281">
          min
        </span>
      </div>
      <span className="text-gold-500 pb-6" data-id="element-282">:</span>
      <div className="bg-navy-800 px-4 py-2 rounded-lg border border-navy-700 shadow-inner" data-id="element-283">
        {format(timeLeft.seconds)}
        <span className="text-sm text-gray-400 block font-sans font-normal" data-id="element-284">
          seg
        </span>
      </div>
    </div>;
};